import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { useAppSelector } from 'shared/lib/redux';
import { VideoInfo } from 'shared/lib/plyr-video-utils';

interface VideoModalState {
  isVideoModalVisible: boolean;
  videoInfo: VideoInfo | null;
}

const initialVideoModalState: VideoModalState = {
  isVideoModalVisible: false,
  videoInfo: null,
};

export const videoModalSlice = createSlice({
  name: 'videoModal',
  initialState: initialVideoModalState,
  reducers: {
    setIsVideoModalVisible: (state, action: PayloadAction<boolean>) => {
      state.isVideoModalVisible = action.payload;
    },
    setVideoInfo: (state, action: PayloadAction<VideoInfo | null>) => {
      state.videoInfo = action.payload;
    },
  },
});

export const { setIsVideoModalVisible, setVideoInfo } = videoModalSlice.actions;

export const useVideoModalStateSelector = () =>
  useAppSelector((state) => state.videoModal);

export const videoModalReducer = videoModalSlice.reducer;
